import { useState } from "react";
import { CheckBox } from "../Common/Checkbox"
import { AvailabitiesBinary, convertToBinary, days, getTimesItemPairHalfHour } from "../../Utils/TimeSlotUtils";
import { Combo } from "../Common/Combo";
import { MaxNumber } from "../../firestore/Types/TutorProfileSchema";

export function WeekSessionPickerMobileScheduleRow( { day, index, availabilities, setAvailabilities } : { day: string[], index: number, availabilities: AvailabitiesBinary, setAvailabilities: (availabilities: AvailabitiesBinary) => void }) {
    const [daySelected, setDaySelected] = useState(false);
    const [from, setFrom] = useState(0);
    const [to, setTo] = useState(47);

    const handleToggleSelected = (name: string, val: boolean) => {
        setDaySelected(val);
        const newAvailbility = { ...availabilities };
        newAvailbility[days[index] as keyof AvailabitiesBinary] = convertToBinary(val ? MaxNumber : 0);
        setAvailabilities(newAvailbility);
    }

    const replaceAt = function (text: string,index: number, replacement: string | any[]) {
		return text.substring(0, index) + replacement + text.substring(index + replacement.length);
	}

    const updateAvailabilities = (from: number, to: number) => {
        var binaryToInsert = convertToBinary(0);
        for (var i = 0; i < binaryToInsert.length; i++) {
            if (i >= from && i <= to) {
                binaryToInsert = replaceAt(binaryToInsert,i, "1");
            }
        }
        const newAvailbility = { ...availabilities };
        newAvailbility[days[index] as keyof AvailabitiesBinary] = binaryToInsert;
        setAvailabilities(newAvailbility);
    }

    const handleSetTo = (value: string) => {
        setTo(Number(value));
        updateAvailabilities(from, Number(value));
    }

    const handleSetFrom = (value: string) => {
        setFrom(Number(value));
        updateAvailabilities(Number(value), to);
    }

    if (day.length > 0) {
        return (
            <div key={index}>
                <div className="flex flex-row basic-form-label ">
                    <div className="basic-form-label grow">
                        {days[index]}:
                    </div>
                    <div className="min-w-[110px]"><CheckBox label={days[index]} name={days[index]} onValueChange={handleToggleSelected} Value={daySelected}></CheckBox></div>
                </div>
                <div className="ml-4">
                    {displayTimes(day)}
                </div>
                {
                    daySelected &&
                    <div className="grid grid-cols-2">
                        <div className="mr-2"><Combo items={getTimesItemPairHalfHour()} label={"From"} name={"timefrom"} defaultValue={from.toString()} onUserChange={handleSetFrom}></Combo></div>
                        <div><Combo items={getTimesItemPairHalfHour()} label={"To"} name={"timeto"} defaultValue={to.toString()} onUserChange={handleSetTo}></Combo></div>
                    </div>
                }
            </div>
        )
    }
    return (
        <div key={index}></div>
    )

    function displayTimes(day: string[]) {
		return (
			day.map((times, index) => (
				<div className="flex flex-row" key={index}>
					<div className="border-l-4 border-b-4 border-indigo-500 h-3 w-3" />
					<div className="basic-form-label pl-2">
						{times}
					</div>
				</div>
			)
        ));
	}
}